<template>
    <div>
        <v-container>
            <v-card>
                <v-card-text>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 md4 v-for="status in statuses" v-bind:key="status.key">
                                <v-switch v-model="selectedStatuses" :label="status.label"
                                          :value="status.key"></v-switch>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="xs-text-left">
                            <v-btn @click="toggleSelection()">{{ toggleText }}</v-btn>
                        </v-layout>
                    </v-container>
                    <v-container>
                        <v-layout d-block>
                            <v-flex>
                                <address-list-pageable :addresses="addressesFiltered" v-if="showAddresses"
                                                       show-status></address-list-pageable>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<style lang="css" scoped>
.xs-text-left {
    text-align: left;
}
</style>

<script>
import {sharedStatusService} from "@/services/shared"
import {service} from '@/services/address';
import AddressListPageable from "@/components/AddressListPageable";

export default {
  name: "cancelled-addresses",
  components: {AddressListPageable},

  data: () => ({
    addressesCancelled: [],
    addressesFiltered: [],
    cancelledStatuses: [],
    statuses: [],
    selectedStatuses: [],
    showAddresses: false
  }),
  methods: {
    loadStatuses() {
      this.cancelledStatuses = sharedStatusService.resolveCancelStatuses();
      this.loadAddresses();
    },
    toggleSelection() {
      if (this.selectedStatuses.length === 0) {
        this.selectedStatuses = this.statuses.map(e => e.key);
        return;
      }
      this.selectedStatuses = [];
    },
    loadAddresses() {
      service.resolveStatuses(this.cancelledStatuses)
        .then(result => {
          this.addressesCancelled = result.data;
          this.addressesFiltered = result.data;
          this.showAddresses = true;
          this.populateStatuses();
        });
    },
    populateStatuses() {
      let statusesFromTotalList = [];
      this.addressesCancelled
        .map(e => e.status)
        .forEach(e => statusesFromTotalList.push(e));
      statusesFromTotalList = [...new Set(statusesFromTotalList)];
      this.selectedStatuses = statusesFromTotalList;
      this.statuses = statusesFromTotalList.map(e => {
        return {
          "key": e,
          "label": sharedStatusService.resolveLabel(e)
        }
      });
    }
  },
  computed: {
    toggleText() {
      if (this.selectedStatuses.length === 0) {
        return "selecteer alles";
      }
      return "selecteer niets"
    }
  },
  watch: {
    // eslint-disable-next-line
    selectedStatuses: function (newlist, oldlist) {
      this.addressesFiltered = this.addressesCancelled.filter(e => newlist.includes(e.status))
    }
  },
  created() {
    this.loadStatuses();
  }
};
</script>
